import React, { memo } from "react";
//css
import classes from "./Dbutton.module.css";
import { CircularProgress } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
const DButtonOutlined = ({
  buyerBtn,
  label,
  onClick,
  disabled,
  labelImg,
  vendorBtn,
  vendorBtnOutlined,
  iconWidth,
  iconHeight,
  btnHeight,
  btnWidth,
  loadingState,
  customClass,
}) => {
  const resolvedTooltipMessage = String(label || "").trim().toLowerCase().startsWith("add")
    ? "Add"
    : "";

  return (
    <Tooltip title={resolvedTooltipMessage} disableHoverListener={!resolvedTooltipMessage} arrow>
      <button
        className={`${
          !buyerBtn ? classes.d_button_outlined : classes.buyerBtnOutlined
        } ${
          !vendorBtnOutlined
            ? classes.d_button_outlined
            : classes.vendorBtnOutlined
        } ${disabled || loadingState ? classes.disabled : ""} ${classes.flex} ${customClass || ""}`}
        style={{ width: `${btnWidth}`, height: `${btnHeight}` }}
        onClick={onClick}
        disabled={disabled || loadingState}
      >
        {labelImg && !loadingState && (
          <img
            src={labelImg}
            style={{
              width: `${iconWidth}`,
              height: `${iconHeight}`,
              marginRight: `${label && `1rem`}`,
            }}
          />
        )}

        {loadingState && (
          <CircularProgress
            size={"18px"}
            thickness={6}
            variant="indeterminate"
            disableShrink
            sx={{
              color: "#3b86c7",
              // marginTop: "4px",
              animationDuration: "450ms",
            }}
          />
        )}

        {label && !loadingState && <span>{label}</span>}
      </button>
    </Tooltip>
  );
};

export default memo(DButtonOutlined);
